/**
 * AgentSelect Component
 * AIDLC Administrative Backend
 *
 * A dropdown of every agent on the live roster. A value saved earlier that the
 * roster no longer has stays selectable, and a roster that cannot be loaded is
 * said on screen with a way to try again.
 */

import { useAgentOptions } from '../../hooks/useAgentOptions';
import { withCurrentOption } from '../../utils/agentOptions';

interface AgentSelectProps {
  id: string;
  value: string;
  onChange: (agentId: string) => void;
  className: string;
}

/** 44px touch target on phones; the desktop height is left to the page's own class. */
const PHONE_TARGET = 'min-h-[44px] sm:min-h-0';

export function AgentSelect({ id, value, onChange, className }: AgentSelectProps) {
  const { options, failed, loading, reload } = useAgentOptions();
  return (
    <>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className={`${className} ${PHONE_TARGET}`}>
        {withCurrentOption(options, value).map((option) => (
          <option key={option.id} value={option.id}>{option.label}</option>
        ))}
      </select>
      {failed && (
        <div role="alert" className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-red-600">
          <span>The agent list could not load. Your saved choice is kept.</span>
          <button
            type="button"
            onClick={reload}
            disabled={loading}
            className={`${PHONE_TARGET} font-medium underline hover:text-red-700 disabled:opacity-50`}
          >
            Try again
          </button>
        </div>
      )}
    </>
  );
}
